module.exports = __webpack_public_path__ + "static/media/farshid1-1-250x251.865488fc.png";